// theme.js or theme.ts
import { createTheme } from '@mui/material/styles';
import '@fontsource/figtree'; //Figtree font import

const theme = createTheme({
  palette: {
    primary: {
      main: '#0766FF', // Azul 1
      dark: '#1A2D4D', // Azul 3
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#A9F618', // Verde
      dark: '#EBB113', // Verde
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#020A23', // Azul 2
      secondary: '#636363', // Cinza body
    },
    grey: {
      50: '#F2F2F2', // Background light
      100: '#BBC2D9', // Body gray-blue
      700: '#636363', // Cinza body
    },
  },
  typography: {
    fontFamily: 'Figtree, sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 400,
      fontSize: '1.5rem',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
      color: '#636363',
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacingValues: {
    // Espaçamentos personalizados
    small: '0.5rem', // 4px
    medium: '1rem', // 16px
    mediumLarge: '2rem', // 32px
    large: '3rem', // 48px
    extralarge: '5.25rem', // 84px
  },
});
export default theme;
